const sample_list ={
    "xyz":{
        name:"三字母分类器",
        data:{
            "x":{
                 'x1':[[1,0,0,0,1], [0,1,0,1,0], [0,0,1,0,0], [0,1,0,1,0], [1,0,0,0,1]],
                 'x2':[[0,0,0,0,1], [1,1,0,1,0], [0,0,1,0,0], [0,1,0,1,1], [1,0,0,0,0]],
                 'x3':[[0,0,0,0,1], [0,1,0,1,0], [0,0,1,0,0], [0,1,0,1,1], [1,0,0,0,0]],
                },
            "y":{
                'y1':[[1,0,0,0,1], [0,1,0,1,0], [0,0,1,0,0], [0,1,0,0,0], [1,0,0,0,0]],
                'y2':[[1,0,0,0,1], [0,1,0,1,0], [0,0,1,0,0], [0,0,1,0,0], [0,0,1,0,0]],
                'y3':[[1,0,0,0,1], [0,1,0,1,0], [0,0,1,0,0], [0,0,1,0,0], [0,1,0,0,0]],
            },
            "z":{
                'z1':[[1,1,1,1,1], [0,0,0,1,0], [0,0,1,0,0], [0,1,0,0,0], [1,1,1,1,1]],
                'z2':[[0,1,1,1,1], [0,0,0,1,0], [0,0,1,0,0], [0,1,0,0,0], [1,1,1,1,1]],
                'z3':[[1,1,1,1,1], [0,0,0,1,0], [0,0,1,0,0], [0,1,0,0,0], [1,1,1,1,0]],
            }
        }
    },
    "number":{
        name:"阿拉伯数字分类器",
        data:{
            "0":{'0_1':[[1,1,1],[1,0,1],[1,0,1],[1,0,1],[1,1,1]]},
            "1":{'1_1':[[0,1,0],[0,1,0],[0,1,0],[0,1,0],[0,1,0]]},
            "2":{'2_1':[[1,1,1],[0,0,1],[1,1,1],[1,0,0],[1,1,1]]},
            "3":{'3_1':[[1,1,1],[0,0,1],[1,1,1],[0,0,1],[1,1,1]]},
            "4":{'4_1':[[1,0,1],[1,0,1],[1,1,1],[0,0,1],[0,0,1]]},
            "5":{'5_1':[[1,1,1],[1,0,0],[1,1,1],[0,0,1],[1,1,1]]},
            "6":{'6_1':[[1,1,1],[1,0,0],[1,1,1],[1,0,1],[1,1,1]]},
            "7":{'7_1':[[1,1,1],[0,0,1],[0,0,1],[0,0,1],[0,0,1]]},
            "8":{'8_1':[[1,1,1],[1,0,1],[1,1,1],[1,0,1],[1,1,1]]},
            "9":{'9_1':[[1,1,1],[1,0,1],[1,1,1],[0,0,1],[1,1,1]]},
        }
    },
    // "hand_writting":{
    //     name:'手写字符训练识别',
    //     data:{
    //         '0':{
    //             '0_1':[[0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0],]
    //         }
    //     }
    // }
}

export {sample_list}
